<template>
    <div style="height: calc(100vh - 360px);overflow-y: auto;">
        <div v-for="(item, index) in voteSubjectList" class="voteSubjectListWrap">
            <div class="voteSubjectList">
                {{ index+1 }}.{{ (item.qastoreContent).replace(/\[tkt\]/g,'______') }}
                【
                {{ item.qastoreType == 'radio' ? '单选题' : '' }}
                {{ item.qastoreType == 'checkbox' ? '多选题' : '' }}
                {{ item.qastoreType == 'gapfill' ? '填空题' : '' }}
                】
                （{{ item.qastoreScore }}分）
            </div>
            <div>
                <span v-for="(item1, index1) in item.workQuestionOptions" class="voteSubjectQuestion" :style="{ color: item1.isAnswer == 'N' ? '#7f7f7f' : '#39b61d' }">
                    {{item.qastoreType!='gapfill'?'选项':'填空'}}{{ index1+1 }}： &nbsp;&nbsp;
                    {{ item1.optionContent }}
                </span>
            </div>
            <div class="desc">
                解析： {{ item.qastoreDesc || '无' }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        voteSubjectList: {
            type:Array,
            required: true
        }
    },
    data() {
        return {

        };
    },
    mounted (){
        console.log(this.voteSubjectList);
    },
    methods: {
    }
};
</script>
<style lang="less">
    .voteSubjectListWrap{
        padding: 12px;
    }
    .voteSubjectList{
        font-size: 14px;
        font-weight: bold;
    }
    .voteSubjectQuestion{
        display: inline-block;
        padding: 10px 10px;
    }
    .desc{
        padding: 10px 10px;
        color: #fb5b5b;
    }
</style>